<template>
<div class="detail">
    <p class="title">{{detail.name}}</p>
    <div class="swiper-box">
        <img :src="arr[active]" alt srcset />
        <swiper :options="options" style="width:370px;height:402px">
            <swiper-slide v-for="(item, index) in arr" :key="index">
                <img :src="item" alt class="swiper-img" @click="active=index" />
            </swiper-slide>
        </swiper>
    </div>
    <div class="box">
        <div class="filter">
            <div :class="{active:filter == 0}" @click="filter=0">产品介绍</div>
            <div :class="{active:filter ==1 }" @click="filter=1">部分产品型号及参数</div>
            <div :class="{active:filter == 2}" @click="filter=2">部分产品电性能测试曲线图</div>
        </div>
        <div class="rich" v-html="html"></div>
    </div>
</div>
</template>

<script>
import {
    productview
} from "../../assets/js/api";
export default {
    data() {
        let _this = this;
        return {
            html: "",
            detail: {},
            arr: [],
            active: 0,
            filter: 0,
            options: {
                width: 370,
                direction: "vertical",
                slidesPerView: 2,
                spaceBetween: 20,
            },
        };
    },
    watch: {
        filter(e) {
            if (e == 0) {
                this.html = this.detail.js;
            } else if (e == 1) {
                this.html = this.detail.xhcs;
            } else {
                this.html = this.detail.qxt;
            }
        },
        "$route.query.id": {
            handler(e) {
                location.reload()
            },
            deep: true,
        },
    },
    created() {
        productview({
            id: this.$route.query.id,
        }).then((r) => {
            this.arr = r.data.images ? r.data.images.split(",") : [];
            this.detail = r.data;
            this.html = r.data.js;
        });
    },
};
</script>

<style lang="less" scoped>
.detail {
    width: 1200px;
    margin: 0 auto;
    background-color: white;
    box-shadow: 0px 12px 12px 0 rgba(0, 0, 0, 0.1);
    padding-top: 90px;
}

.title {
    text-align: center;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(112, 112, 112, 1);
    margin-bottom: 60px;
}

.swiper-box {
    display: flex;
    justify-content: space-between;
    height: 456px;
    width: 1200px;
    margin: 0 auto;
    margin-bottom: 50px;

    &>img {
        width: 800px;
        height: 100%;
        // object-fit: cover;
    }

    .swiper-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
}

.box {
    .filter {
        height: 60px;
        background: #f0f0f0;
        display: flex;
        margin-bottom: 40px;

        div {
            cursor: pointer;
            height: 100%;
            text-align: center;
            padding: 0 53px;
            box-sizing: border-box;
            line-height: 60px;
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: rgba(0, 0, 0, 1);
        }

        div.active {
            background: white;
            border-top: 3px solid #1270cc;
        }
    }
}
</style>
